import { api } from '../core/api';
import { AppInfo, ConnectedServices } from '../../types/app/appInfo.types';

export const getAppInfo = () => api.get<AppInfo>('Common/AppInfo').then((res) => res.data);

export const getConnectedServices = () =>
  api.get<ConnectedServices>('Common/ConnectedServices').then((res) => res.data);
